export const cardNumberFromHRef = () => {
    let tmpString = ""
    tmpString = window.location.toString().split('/').slice(-1)[0];
    if(tmpString && (tmpString.length > 2 && tmpString.substring(0, 2) === "DK")) {
        const redirectCheck = tmpString
        return redirectCheck
    }
    else {
        const redirectCheck = "DK"
        return redirectCheck
    }
}
